module.exports = __webpack_public_path__ + "static/media/tt.078d46b4.png";